import React, { useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../shared/CustomButton';
import { FaSave } from 'react-icons/fa';

const ReportForm = ({
    report,
    isSaving,
    formAction
}) => {
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        setError       
    } = useForm({defaultValues: report ? 
        {
            id: report.id,
            title: report.title,
            template: report.template,
            report_query: report.report_query,
            parameters: report.parameters
        } : {}
    });

    const resetForm = () => {
        reset({
            id: '',
            title: '',
            template: '',
            report_query: '',
            parameters: ''
        });
    }

    useEffect(() => {
        if (report) {
            reset({
                ...report,
                parameters: Array.isArray(report.parameters)
                    ? JSON.stringify(report.parameters)
                    : report.parameters
            });
        }
    }, [reset, report]);

    const onSubmit = async (data) => {
        try {
            const formattedData = {
                ...data,
                parameters: typeof data.parameters === 'string'
                    ? JSON.parse(data.parameters)
                    : data.parameters
            };

            const success = await formAction(formattedData);

            if (success) {
                resetForm();
            }
        } catch (error) {
            if (error instanceof SyntaxError) {
                setError('parameters',  {
                    type: 'manual',
                    message: "Invalid JSON format. Use ['param1', 'param2']"
                });
            }
            else if (error.response && error.response.status === 422) {
                console.log(error.response.data.errors);
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // other errors to be handled by saveReport in Reports.jsx
            }
        }
    }
  return (
        <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
            <Row className="g-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-bold">Report Title</Form.Label>
                        <Form.Control
                            type='text'
                            {...register('title', { required: 'Enter report title' })}
                            isInvalid={!!errors.title}
                        />
                        <Form.Control.Feedback type="invalid">{errors.title?.message}</Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="fw-bold">Jasper Template Name (.jrxml)</Form.Label>
                        <Form.Control
                            type='text'
                            {...register('template', { required: 'Enter template name' })}
                            isInvalid={!!errors.template}
                        />
                        <Form.Control.Feedback type="invalid">{errors.template?.message}</Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="fw-bold">SQL Report Query</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={8}
                            style={{ fontFamily: 'monospace' }}
                            {...register('report_query', { required: 'SQL query is required' })}
                            isInvalid={!!errors.report_query}
                        />
                        <Form.Control.Feedback type="invalid">{errors.report_query?.message}</Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="fw-bold">Parameters (JSON Array)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder='e.g. ["startDate", "endDate", "siteId"]'
                            {...register('parameters', { required: 'Parameters are required' })}
                            isInvalid={!!errors.parameters}
                        />
                        <Form.Text className="text-muted">Must be a valid JSON array of strings.</Form.Text>
                        <Form.Control.Feedback type="invalid">{errors.parameters?.message}</Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <div className="mt-4 text-end">
                <CustomButton
                    isSaving={isSaving}
                    title={isSaving ? 'Saving...' : 'Save'}
                    icon={<FaSave />}
                />
            </div>
        </Form>
    )
}

export default ReportForm